import {
  DashboardIcon,
  GeohashIcon,
  H3Icon,
  LineIcon,
  LookupIcon,
  MapIcon,
  POIIcon
} from "@/assets/icons";
import { SpatialAggregationType } from "@/types/common";
import { EOutputAnalysisType } from "@/types/spatial";

import { twMerge } from "tailwind-merge";

type DatasetTypeIconProps = {
  type: SpatialAggregationType;
  className?: string;
};

export const DatasetTypeIcon = ({ type, className }: DatasetTypeIconProps) => {
  switch (type) {
    case EOutputAnalysisType.GRID:
    case EOutputAnalysisType.PROFILING:
      return (
        <div
          className={twMerge(
            "min-w-5 bg-teal-50 rounded-[4px] h-5 flex items-center justify-center flex-shrink-0",
            className
          )}
        >
          <LookupIcon className="fill-teal-500 size-4" title="Grid icon" />
        </div>
      );

    case "polygon":
      return (
        <div
          className={twMerge(
            "min-w-5 bg-orange-50 rounded-[4px] h-5 flex items-center justify-center flex-shrink-0",
            className
          )}
        >
          <DashboardIcon
            title="Polygon icon"
            className="fill-orange-700 size-4"
          />
        </div>
      );

    case "adm_area":
      return (
        <div
          className={twMerge(
            "min-w-5 bg-blue-50 rounded-[4px] h-5 flex items-center justify-center flex-shrink-0",
            className
          )}
        >
          <MapIcon title="Adm area icon" className="fill-blue-700 size-4" />
        </div>
      );

    case "poi":
      return (
        <div
          className={twMerge(
            "min-w-5 bg-purple-50 rounded-[4px] h-5 flex items-center justify-center flex-shrink-0",
            className
          )}
        >
          <POIIcon className="fill-purple-700 size-4" title="POI icon" />
        </div>
      );

    case "H3":
      return (
        <div
          className={twMerge(
            "min-w-5 bg-green-50 rounded-[4px] h-5 flex items-center justify-center flex-shrink-0",
            className
          )}
        >
          <H3Icon title="H3 icon" className="fill-green-700 size-4" />
        </div>
      );

    case "line":
      return (
        <div
          className={twMerge(
            "min-w-5 bg-orange-50 rounded-[4px] h-5 flex items-center justify-center flex-shrink-0",
            className
          )}
        >
          <LineIcon title="Line icon" className="size-4 fill-orange-700-2" />
        </div>
      );

    case "geohash":
      return (
        <div
          className={twMerge(
            "min-w-5 bg-yellow-50 rounded-[4px] h-5 flex items-center justify-center flex-shrink-0",
            className
          )}
        >
          <GeohashIcon
            title="Geohash icon"
            className="size-4 fill-yellow-800"
          />
        </div>
      );

    default:
      return null;
  }
};
